import { Pipe, PipeTransform } from '@angular/core';
import { isEmpty } from 'lodash';

@Pipe({
  name: 'isEmpty'
})
export class IsEmptyPipe implements PipeTransform {
    transform(value: any) {
      return isEmpty(value);
    }
}
